/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_RentInputs */

const cs_property_legal_rent = /** @type {(inputs: Property_Legal_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nájemné`)
};

const en_property_legal_rent = /** @type {(inputs: Property_Legal_RentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rent`)
};

/**
* | output |
* | --- |
* | "Rent" |
*
* @param {Property_Legal_RentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_rent = /** @type {((inputs?: Property_Legal_RentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_RentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_rent(inputs)
	return cs_property_legal_rent(inputs)
});